<template lang="pug">
    v-dialog(v-model="openModalNotif" hide-overlay  max-width="500px")
        v-card
            v-card-text
                v-alert(
                    style="margin-left :-25px; margin-right :-24px; margin-bottom :-20px"
                    border="bottom"
                    color="pink darken-1"
                    dark          
                    ) {{errorNotif}}
                    br
                    v-btn(text  color="white" @click="closeModal" style="float: right") OK
</template>
<script>
export default {
    name: "ModalErrorNotif",
    components: {

    },
    props: ['openModalNotif','errorNotif'],
    methods: {
        closeModal (){
            this.$emit("closeModal", false);
        }
    }
};
</script>